<app-header></app-header>
<app-navigation-bar (onBurgerClicked)="toggleDrawer()"></app-navigation-bar>
<app-drawer [open]="drawerIsOpen" (onClose)="drawerIsOpen=false"></app-drawer>

<div class="page-content">

  <h1>{{getString("preferences")}}</h1>

  <div class="preferences-container">
    
    <p>
      <app-custom-checkbox [value]="hidePurchasedItems" [label]="getString('hidePurchasedItems')" (onChange)="hidePurchasedItemsChanged($event)"></app-custom-checkbox>
    </p>
    <div class="setting-description-text">
      {{getString('hidePurchasedItemsText')}}
    </div>

    <p>
      <app-custom-checkbox [value]="ignoreSdPriceOnWishlist" [label]="getString('ignoreSdPriceOnWishlist')" (onChange)="ignoreSdPriceOnWishlistChanged($event)"></app-custom-checkbox>
    </p>
    <div class="setting-description-text">
      {{getString('ignoreSdPriceOnWishlistText')}}
    </div>

    <div class="theme-mode-setting">
      <span class="theme-mode-title">{{getString('nightMode')}}</span>
      <div class="theme-mode-options">
        <div class="radio-option" (click)="themeModeChanged('auto')">
          <div class="radio-circle" [class.selected]="themeMode === 'auto'">
            <div class="radio-inner" *ngIf="themeMode === 'auto'"></div>
          </div>
          <span class="radio-label">{{getString('themeModeAuto')}}</span>
        </div>
        <div class="radio-option" (click)="themeModeChanged('dark')">
          <div class="radio-circle" [class.selected]="themeMode === 'dark'">
            <div class="radio-inner" *ngIf="themeMode === 'dark'"></div>
          </div>
          <span class="radio-label">{{getString('themeModeDark')}}</span>
        </div>
        <div class="radio-option" (click)="themeModeChanged('light')">
          <div class="radio-circle" [class.selected]="themeMode === 'light'">
            <div class="radio-inner" *ngIf="themeMode === 'light'"></div>
          </div>
          <span class="radio-label">{{getString('themeModeLight')}}</span>
        </div>
      </div>
    </div>

    <div *ngIf="success" class="green-text">{{getString('settingsSaveSuccess')}}</div>
    <div class="red-text">
      <span>{{errorMessage}}</span>
    </div>
    <button type="button" class="blue-button" (click)="ok()">{{getString('save2')}}</button>
  </div>

</div>

<app-authentication #authentication></app-authentication>
